import React, { useState } from "react";
import { Button } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";

const KycRatingCookie = ({ onAccept, onDecline }) => {
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);

    return (
        <div className="kyc-cookie-wrapper">
            <div className="kyc-cookie-box">

                <div className="kyc-cookie-text">
                    <h6>⭐ Rate Your KYC Experience</h6>

                    <p>
                        How was your KYC verification process? (Out of 10)
                    </p>

                    <div className="kyc-cookie-stars">
                        {[...Array(10)].map((_, i) => {
                            const value = i + 1;

                            return (
                                <StarIcon
                                    key={value}
                                    onClick={() => setRating(value)}
                                    onMouseEnter={() => setHover(value)}
                                    onMouseLeave={() => setHover(0)}
                                    className="kyc-cookie-star"
                                    style={{
                                        color: value <= (hover || rating) ? "#FFD700" : "#444",
                                    }}
                                />
                            );
                        })}
                    </div>

                    {rating > 0 && (
                        <small className="kyc-cookie-selected">
                            Selected: {rating}/10
                        </small>
                    )}
                </div>

                <div className="kyc-cookie-actions">
                    <Button
                        variant="outlined"
                        className="cookie-btn decline"
                        onClick={onDecline}
                    >
                        Skip
                    </Button>

                    <Button
                        variant="contained"
                        className="cookie-btn accept"
                        onClick={() => rating > 0 && onAccept(rating)}
                        disabled={!rating}
                    >
                        Submit
                    </Button>
                </div>

            </div>
        </div>
    );
};

export default KycRatingCookie;